<template>
  <Dropdown
    v-model="selectedHosting"
    :options="hostingOptions"
    option-label="label"
    option-value="value"
    placeholder="All Hostings"
    class="tw-border-none tw-outline-none tw-shadow-none tw-bg-none tw-bg-transparent tw-items-center tw-max-w-full sm:tw-max-w-72"
    input-class="tw-text-3xl md:tw-text-[40px] tw-font-light tw-p-0 tw-leading-normal"
    panel-class="tw-max-w-xs md:tw-max-w-sm lg:tw-max-w-lg xl:tw-max-w-2xl"
    filter
    @change="(e) => emits('selectHosting', e.value)"
  />
</template>

<script setup>
import Dropdown from "primevue/dropdown";
import { defineProps, defineEmits, computed, onMounted, ref, watch } from "vue";
import axios from "axios";
import { API_BASE_URL } from "@/consts";

const emits = defineEmits(["selectHosting"]);
const props = defineProps({
  networkAdminId: {
    type: [String, Number],
    default: null,
  },
  selectedPodcaster: {
    type: [String, Number],
    default: "all",
  },
});

const selectedHosting = ref("all");
const hostings = ref([]);

const formatHostingLabel = (value) => {
  if (!value) return "Unknown";
  const str = value.toString();
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const hostingOptions = computed(() => {
  const options = hostings.value.map((h) => ({
    value: h,
    label: formatHostingLabel(h),
  }));
  options.unshift({ label: "All Hostings", value: "all" });
  return options;
});

// Reset selection if the current hosting is no longer present in the options
watch(
  hostingOptions,
  (options) => {
    const hasValue = options.some((opt) => opt.value === selectedHosting.value);
    if (!hasValue) {
      selectedHosting.value = "all";
      emits("selectHosting", "all");
    }
  },
  { immediate: true }
);

onMounted(() => {
  fetchHostings();
});

watch(
  () => props.selectedPodcaster,
  () => {
    selectedHosting.value = "all";
    emits("selectHosting", "all");
    fetchHostings();
  }
);

const fetchHostings = async () => {
  try {
    const token =
      localStorage.getItem("networkAdminToken") ||
      localStorage.getItem("podcastAdminToken");
    const { data } = await axios.get(
      `${API_BASE_URL}/podcast_events/hosting-options`,
      {
        params: {
          podcasterId: props.selectedPodcaster,
          networkAdminId: props.networkAdminId,
        },
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    hostings.value = data?.hostings || [];
  } catch (err) {
    console.error("Failed to fetch hosting options", err);
  }
};
</script>
